var _toConsumableArray = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var LogicalFunctions = require('../../formulas/functions/logical');

var ReferenceFunctions = require('../../formulas/functions/reference');

var FormulaError = require('../../formulas/error');

var _require = require('../../formulas/helpers'),
    FormulaHelpers = _require.FormulaHelpers;

var _require2 = require('../parsing'),
    Parser = _require2.Parser;

var lexer = require('../lexing');

var Utils = require('./utils');

var DepParser = /*#__PURE__*/function () {
  "use strict";

  /**
   *
   * @param {{onVariable: Function}} [config]
   */
  function DepParser(config) {
    _classCallCheck(this, DepParser);

    this.logs = [];
    this.data = [];
    this.utils = new Utils(this);
    config = Object.assign({
      onVariable: function onVariable() {
        return null;
      }
    }, config);
    this.utils = new Utils(this);
    this.onVariable = config.onVariable;
    this.functions = Object.assign({}, ReferenceFunctions, LogicalFunctions);
    this.parser = new Parser(this, this.utils);
  }
  /**
   * Get value from the cell reference
   * @param ref
   * @return {*}
   */


  _createClass(DepParser, [{
    key: "getCell",
    value: function getCell(ref) {
      // console.log('get cell', JSON.stringify(ref));
      if (ref.row != null) {
        if (ref.sheet == null) ref.sheet = this.position ? this.position.sheet : undefined;
        var idx = this.data.findIndex(function (element) {
          return element.from && element.from.row <= ref.row && element.to.row >= ref.row && element.from.col <= ref.col && element.to.col >= ref.col || element.row === ref.row && element.col === ref.col && element.sheet === ref.sheet;
        });
        if (idx === -1) this.data.push(ref);
      }

      return 0;
    }
    /**
     * Get values from the range reference.
     * @param ref
     * @return {*}
     */

  }, {
    key: "getRange",
    value: function getRange(ref) {
      // console.log('get range', JSON.stringify(ref));
      if (ref.from.row != null) {
        if (ref.sheet == null) ref.sheet = this.position ? this.position.sheet : undefined;
        var idx = this.data.findIndex(function (element) {
          return element.from && element.from.row === ref.from.row && element.from.col === ref.from.col && element.to.row === ref.to.row && element.to.col === ref.to.col;
        });
        if (idx === -1) this.data.push(ref);
      }

      return [[0]];
    }
    /**
     * TODO:
     * Get references or values from a user defined variable.
     * @param name
     * @return {*}
     */

  }, {
    key: "getVariable",
    value: function getVariable(name) {
      // console.log('get variable', name);
      var res = {
        ref: this.onVariable(name, this.position.sheet)
      };
      if (res.ref == null) return FormulaError.NAME;
      if (FormulaHelpers.isCellRef(res)) this.getCell(res.ref);else {
        this.getRange(res.ref);
      }
      return 0;
    }
    /**
     * Retrieve values from the given reference.
     * @param valueOrRef
     * @return {*}
     */

  }, {
    key: "retrieveRef",
    value: function retrieveRef(valueOrRef) {
      if (FormulaHelpers.isRangeRef(valueOrRef)) {
        return this.getRange(valueOrRef.ref);
      }

      if (FormulaHelpers.isCellRef(valueOrRef)) {
        return this.getCell(valueOrRef.ref);
      }

      return valueOrRef;
    }
    /**
     * The functions that can return a reference instead of a value as normal functions.
     * Note: Not all functions from "Lookup and reference" category can return a reference.
     * {@link https://support.office.com/en-ie/article/lookup-and-reference-functions-reference-8aa21a3a-b56a-4055-8257-3ec89df2b23e}
     * @param name - Reference function name.
     * @param args - Arguments that pass to the function.
     */

  }, {
    key: "callRefFunction",
    value: function callRefFunction(name, args) {
      var _this = this;

      args.forEach(function (arg) {
        _this.retrieveRef(arg);
      });
      name = name.toUpperCase();

      if (this.functions[name]) {
        var res;

        try {
          var _this$functions;

          res = (_this$functions = this.functions)[name].apply(_this$functions, [this].concat(_toConsumableArray(args)));
        } catch (e) {
          // allow functions throw FormulaError, this make functions easier to implement!
          if (e instanceof FormulaError) {
            return e;
          } else {
            throw e;
          }
        }

        if (res === undefined) {
          return {
            value: 0,
            ref: {}
          };
        }

        return FormulaHelpers.checkFunctionResult(res);
      } else {
        if (!this.logs.includes(name)) this.logs.push(name); // console.log(`Function ${name} is not implemented`);

        return {
          value: 0,
          ref: {}
        };
      }
    }
    /**
     * Call an excel function.
     * @param name - Function name.
     * @param args - Arguments that pass to the function.
     * @return {*}
     */

  }, {
    key: "callFunction",
    value: function callFunction(name, args) {
      var _this2 = this;

      args.forEach(function (arg) {
        if (arg === null) return;

        _this2.utils.extractRefValue(arg);
      });
      return {
        value: 0,
        ref: {}
      };
    }
    /**
     * Check and return the appropriate formula result.
     * @param result
     * @return {*}
     */

  }, {
    key: "checkFormulaResult",
    value: function checkFormulaResult(result) {
      this.retrieveRef(result);
    }
    /**
     * Parse an excel formula and return the dependencies
     * @param inputText
     * @param position
     * @returns {Array.<{}>}
     */

  }, {
    key: "parse",
    value: function parse(inputText, position) {
      if (inputText.length === 0) throw Error('Input must not be empty.');
      this.data = [];
      this.position = position;
      var lexResult = lexer.lex(inputText);
      this.parser.input = lexResult.tokens;
      var res = this.parser.formulaWithBinaryOp();
      this.checkFormulaResult(res);

      if (this.parser.errors.length > 0) {
        var error = this.parser.errors[0];
        var line = error.previousToken.startLine,
            column = error.previousToken.startColumn + 1;
        var msg = '\n' + inputText.split('\n')[line - 1] + '\n';
        msg += Array(column - 1).fill(' ').join('') + '^\n';
        error.message = msg + "Error at position ".concat(line, ":").concat(column, "\n") + error.message;
        console.error(error.toString());
      }

      return this.data;
    }
  }]);

  return DepParser;
}();

module.exports = {
  DepParser: DepParser
};